import { EEntityType } from 'shared/map-search/types/chatModal';

import { IApplicationState } from '../../types/redux';

export function selectOfferChatOfferType(state: IApplicationState): EEntityType | undefined {
  return state.chatModal.offerType;
}
